import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
	AddressIcon,
	CloseIcon,
	DepartmentIcon,
	EarlyWarningIcon,
	IconDepth,
	IconMagnitude,
	IconTime,
	IconTriggerType,
	IdIcon,
	NameIcon,
	SearchIcon,
} from "../iconSet/IconSet";
import useInputValidate from "../../hooks/useInputValidate";
import InputGroup from "../inputComp/InputGroup";
import {
	ConfigurationPropsTypes,
	DataForDesignTypes,
	TabTypes,
} from "./ConfigurationType";
import { InputGroupPropsTypes } from "../inputComp/InputGroupType";
import WorkflowCanvas from "../workflowCanvas/WorkflowCanvas";
import { FlowDiagramRef, WorkflowTypes } from "../flowchart/FlowDiagram";
import { AddInfomationDetais } from "../../services/UserService";
import { SelectItemTypes } from "../../CommonTypes";
import { useLocation } from "react-router-dom";
import { UserType } from "../OrganizationAddUserComp/OrganizationAddUserTypes";
import SpecificAreaTable, { AreaType } from "./SpecificAreaTable";
import AlertDialog from "../popupComp/AlertDialog";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";
import FlowDiagramWrapper from "../flowchart/FlowDiagram";
import { useTheme } from "../../context/ThemeContext";

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import MapComp, { Coordinate } from "../createWarningComp/MapComp";
import { APIAddWorkflowInfos, APIGetAllWorkflowInfos, APIRequestCoordinate, APIRequestWorkflowInfo, APIResponseGetAllWorkflowInfo } from "./ConfigurationService";

const Configuration = (props: ConfigurationPropsTypes) => {

	const BASE_URL = process.env.REACT_APP_BASE_URL

	const flowRef = useRef<FlowDiagramRef>(null);

	const { theme } = useTheme()

	// Tab data
	const tabs: string[] = ["information", "design"];
	const [selectedTab, setSelectedTab] = useState<TabTypes>("information");

	const [alertDialogState, setAlertDialogState] = useState(false);
		const [alertTitle, setAlertTitle] = useState('');
		const [alertDescription, setAlertDescription] = useState('');
		const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
		const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK
	
	const showAlertDialog = (
		title: string,
		description: string,
		yesCallback?: () => void,
		okCallback?: () => void
		) => {
		setAlertTitle(title);
		setAlertDescription(description);
		setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
		setAlertOkCallback(() => okCallback);   // Will trigger only on OK
		setAlertDialogState(true);
		};

	const [severity, setSeverity] = useState<SelectItemTypes[]>([
		{name: "White", value: "white"},
		{name: "Yellow", value: "yellow"},
		//{name: "Amber", value: "amber"},
		{name: "Orange", value: "amber"},
		{name: "Red", value: "red"},
	])

	const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false)
	const [isDataPickerLoading, setIsDataPickerLoading] = useState<boolean>(false);

	const allUsers = useRef<APIResponseGetAllWorkflowInfo[]>([])
	const [filteredUsersData, setFilteredUserData] = useState<APIResponseGetAllWorkflowInfo[]>([]);

	const [initialMultiPolygon, setInitialMultiPolygon] = useState<APIRequestCoordinate[][]>([])

	// Popup status
	const [isUserPopupOpen, setIsUserPopupOpen] = useState<boolean>(false);

	// Table data
	const [areaTableData, setAreaTableDate] = useState<AreaType[]>([])

	// Select menu options
	// Departments
	const [userDepartment, setUserDepartment] = useState<SelectItemTypes[]>([
		{ value: "EWD", name: "EW Department" },
		{ value: "IRD", name: "Irrigation Department" },
		{ value: "NDEF", name: "National Defence Department" },
	]);

	const [departmentValue, setDepartmentValue]= useState<string>('');

	// Hazards
	const [selectHazard, setSelectHazard] = useState<SelectItemTypes[]>([
		// { value: "LSW", name: "Landslide" },
		{ value: "FLW", name: "Flood" },
		{ value: "HRW", name: "Heavy Rain" },
		// { value: "EW", name: "Explosion" },
		{ value: "TW", name: "Tsunami" },
		// { value: "BHW", name: "Biological Hazard" },
		// { value: "FW", name: "Fire" },
		// { value: "CW", name: "Cyclone" },
		// { value: "WFW", name: "Wild Fire" },
		// { value: "EQW", name: "Earthquake" },
		{ value: "HWN", name: "High Wind" },
		{ value: "MWA", name: "Marine Weather" },
		// { value: "NTW", name: "Nuclear Threat" },
		// { value: "ASW", name: "Air Strike" },
		{ value: "LIG", name: "Lightning" },
		{ value: "CUS", name: "Custom warning" },
		{ value: "GUS", name: "Gust warning" },
	]);

	// Warnings
	const [selectWarning, setSelectWarning] = useState<SelectItemTypes[]>([
		{ value: "WR", name: "Early Warning" },
		{ value: "IFR", name: "Information" },
		{ value: "ALT", name: "Alert" },
	]);

	// Localization
	const [localization, setLocalization] = useState<SelectItemTypes[]>([
		{ value: "all_country", name: "All Country" },
		{ value: "specific_area", name: "Specific Area" },
	])

	// Warning type
	const [workflowType, setWorkflowType] = useState<SelectItemTypes[]>([
		{ value: "prod", name: "Production" },
		{ value: "test", name: "Test" },
	])

	const [workflowTriggerType, setWorkflowTriggerType] = useState<SelectItemTypes[]>([])

	// Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const [test, setTest] = useState();

	// Input fields
	const nameRef = useRef<HTMLInputElement>(null);
	const idRef = useRef<HTMLInputElement>(null);
	const departmentRef = useRef<HTMLSelectElement>(null);
	const hzTypeRef = useRef<HTMLSelectElement>(null);
	const warningTypeRef = useRef<HTMLSelectElement>(null);
	const localizationRef = useRef<HTMLSelectElement>(null)
	const workflowTypeRef = useRef<HTMLSelectElement>(null)

	const triggerTypeRef = useRef<HTMLSelectElement | null>(null)

	const [list, setList] = useState<WorkflowTypes[]>([]);
	//const [list, setList] = useState<string>('')

	const location = useLocation();
	const response = location.state; // The original login response JSON

	//console.log("Received in Configuration:", response);

	const [isLocalizationTableOpen, setIsLocalizationTableOpen] = useState<boolean>(false)
	// Handle click localization change
	const handleLocalizationChange = (event: ChangeEvent<HTMLSelectElement | HTMLInputElement >) => {
		event.preventDefault()
		if (event.target.value === 'all_country'){
			setIsLocalizationTableOpen(false)
		} else if (event.target.value === 'specific_area'){
			setIsLocalizationTableOpen(true)
		}
	}

	const handleHazardChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const value = event.target.value

		const otherSelect = [
			{ value: "manual", name: "Manual" },
		]

		const earthquakeSelect = [
			{ value: "auto", name: "Automate" },
			{ value: "manual", name: "Manual" },
		]

		if (value === 'EQW')
		{
			setWorkflowTriggerType(earthquakeSelect)
		}
		else 
		{
			setWorkflowTriggerType(otherSelect)
		}
	}

	// Input field list
	const formItems: InputGroupPropsTypes[] = [
		{
			type: "text",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter id",
			label: "id",
			componentInputElement: idRef,
			id: "get_id",
			required: true,
			dataPicker: true,
			isDataPickerOpen: isDataPickerOpen,
			setIsDataPickerOpen: setIsDataPickerOpen,
		},
		{
			type: "text",
			icon: <NameIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter name",
			label: "name",
			componentInputElement: nameRef,
			required: true,
		},
		{
			type: "select",
			icon: <DepartmentIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "department",
			componentSelectElement: departmentRef,
			required: true,
			optionList: userDepartment,
			//value: departmentValue,
			placeholder: "Select department",
		},
		{
			type: "select",
			icon: <EarlyWarningIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "hazard category",
			componentSelectElement: hzTypeRef,
			required: true,
			optionList: selectHazard,
			placeholder: "Select hazard type",
			onChange: (event) => {
				handleHazardChange(event)
			}
		},
		{
			type: "select",
			icon: <EarlyWarningIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "process category",//"warning type",
			componentSelectElement: warningTypeRef,
			required: true,
			optionList: selectWarning,
			placeholder: "Select category",
		},
		{
			type: "select",
			icon: <AddressIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "localization",//"warning type",
			componentSelectElement: localizationRef,
			optionList: localization,
			onChange: handleLocalizationChange,
			placeholder: "Select Localization Type",
			required: true,
		},
		{
			type: "select",
			icon: <AddressIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "Workflow Type",
			componentSelectElement: workflowTypeRef,
			optionList: workflowType,
			placeholder: "Select Workflow Type",
			required: true,
		},
		{
			type: "select",
			icon: <IconTriggerType width="2rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "Trigger type",
			componentSelectElement: triggerTypeRef,
			optionList: workflowTriggerType,
			placeholder: "Select Trigger Type",
			onChange(event) {
				handleChangeTriggerType(event)
			},
			required: true,
		}
	]

	const msgEnRef = useRef<HTMLTextAreaElement>(null)
	const msgDvRef = useRef<HTMLTextAreaElement>(null)
	const msgBnRef = useRef<HTMLTextAreaElement>(null)
	const messageFields: InputGroupPropsTypes[] = [
		{
			type: "text-area",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter message in English",
			label: "Message (English)",
			componentTextArea: msgEnRef,
			id: "message_en_tsunami",
			required: true
		},
		{
			type: "text-area",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter message in Dhivehi",
			label: "Message (Dhivehi)",
			componentTextArea: msgDvRef,
			id: "message_dv_tsunami",
			required: true
		},
		{
			type: "text-area",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter message in Bengali",
			label: "Message (Bengali)",
			componentTextArea: msgBnRef,
			id: "message_bn_tsunami",
			required: true
		}
	]

	const minDepthRef = useRef<HTMLInputElement>(null)
	const maxDepthRef = useRef<HTMLInputElement>(null)
	const minMagnitudeRef = useRef<HTMLInputElement>(null)
	//const maxMagnitudeRef = useRef<HTMLInputElement>(null)
	const maxMagRef = useRef<HTMLInputElement>(null)
	const thresholdFields: InputGroupPropsTypes[] = [
		{
			type: "number",
			icon: <IconDepth width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter min depth",
			label: "Minimum Depth",
			componentInputElement: minDepthRef,
			id: "threshold_min_depth",
			required: true,
			min: 0
		},
		{
			type: "number",
			icon: <IconDepth width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter max depth",
			label: "Maximum Depth",
			componentInputElement: maxDepthRef,
			id: "threshold_max_depth",
			required: true,
			min: 0
		},
		{
			type: "number",
			icon: <IconMagnitude width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter min magnitude",
			label: "Minimum Magnitude",
			componentInputElement: minMagnitudeRef,
			id: "threshold_min_magnitude",
			required: true,
			min: 0
		},
		{
			type: "number",
			icon: <IconMagnitude width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter max magnitude",
			label: "Maximum Magnitude",
			componentInputElement: maxMagRef,
			id: "threshold_max_magnitude",
			required: true,
			min: 0
		}
	]

	const effectiveHoursRef = useRef<HTMLInputElement>(null)
	const severityRef = useRef<HTMLSelectElement>(null)
	const infoFields: InputGroupPropsTypes[] = [
		{
			type: "number",
			icon: <IconTime width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter effective hours",
			label: "Effective hours",
			componentInputElement: effectiveHoursRef,
			id: "info_effective_hours",
			required: true,
			min: 0
		},
		{
			type: "select",
			icon: <EarlyWarningIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Select severity",
			label: "Severity",
			componentSelectElement: severityRef,
			id: "info_severity",
			required: true,
			optionList: severity,
			min: 0
		}
	]

	const handleClickFilteredInfoWarningDiagram = (info: APIResponseGetAllWorkflowInfo): void => {
		if (info.triggerType === 'auto')
		{
			if (idRef.current && nameRef.current && departmentRef.current && hzTypeRef.current && warningTypeRef.current && workflowTypeRef.current && triggerTypeRef.current && localizationRef.current) 
			{
				// Set input values
				idRef.current.value = info.warningId;
				nameRef.current.value = info.username;
				departmentRef.current.value = info.departments;
				hzTypeRef.current.value = info.hazardType;
				warningTypeRef.current.value = info.warningType;
				workflowTypeRef.current.value = info.workflowType;
				triggerTypeRef.current.value = info.triggerType
				localizationRef.current.value = info.localizationType
	
				handleChangeTriggerType({target: {value: info.triggerType}} as any)
				handleHazardChange({target: {value: info.hazardType}} as any)
	
				const areas: APIRequestCoordinate[][] = parseAreas(info.areas)
				setInitialMultiPolygon(areas)

				setTimeout(() => {
					if (minDepthRef.current && maxDepthRef.current && minMagnitudeRef.current && maxMagRef.current && msgEnRef.current && msgDvRef.current && msgBnRef.current && effectiveHoursRef.current && severityRef.current) 
					{
						minDepthRef.current.valueAsNumber = info.minDepth;
						maxDepthRef.current.valueAsNumber = info.maxDepth;
						minMagnitudeRef.current.valueAsNumber = info.minMagnitude;
						maxMagRef.current.valueAsNumber = info.maxMagnitude;
						msgEnRef.current.value = info.msgEn;
						msgDvRef.current.value = info.msgDv;
						msgBnRef.current.value = info.msgBn;
						effectiveHoursRef.current.valueAsNumber = info.effectiveHours
						severityRef.current.value = info.severity
					}
				}, 0)
			}
		}
		else 
		{
			if (idRef.current && nameRef.current && departmentRef.current && hzTypeRef.current && warningTypeRef.current && workflowTypeRef.current && triggerTypeRef.current && localizationRef.current) 
			{
				// Set input values
				idRef.current.value = info.warningId;
				nameRef.current.value = info.username;
				departmentRef.current.value = info.departments;
				hzTypeRef.current.value = info.hazardType;
				warningTypeRef.current.value = info.warningType;
				workflowTypeRef.current.value = info.workflowType;
				triggerTypeRef.current.value = info.triggerType
				localizationRef.current.value = info.localizationType
	
				handleChangeTriggerType({target: {value: info.triggerType}} as any)
				handleHazardChange({target: {value: info.hazardType}} as any)
	
				const areas: APIRequestCoordinate[][] = parseAreas(info.areas)
				setInitialMultiPolygon(areas)
	
			}
		}
		setIsDataPickerOpen(false);
	}

	const parseAreas = (jsonString: string): APIRequestCoordinate[][] => {
		try {
			const parsed = JSON.parse(jsonString);
			return parsed as APIRequestCoordinate[][];
		} catch (error) {
			console.error("Invalid JSON:", error);
			return [];
		}
	}

	// Custom hook
	const { validateField } = useInputValidate();

	// Handle info next button click
	const handleInfoNextClick = () => {
		// Common ref null checks
		if (!idRef.current || !nameRef.current || !departmentRef.current || 
			!hzTypeRef.current || !warningTypeRef.current || !workflowTypeRef.current || 
			!triggerTypeRef.current || !localizationRef.current) {
			return;
		}
	
		const isValidDepartment: boolean = validateField(departmentRef);
		const isValidHz: boolean = validateField(hzTypeRef);
		const isValidWarning: boolean = validateField(warningTypeRef);
		const isValidId: boolean = validateField(idRef);
		const isValidName: boolean = validateField(nameRef);
		const isTriggerType: boolean = validateField(triggerTypeRef);
		const isLocalization: boolean = validateField(localizationRef);
		const isWorkflowType: boolean = validateField(workflowTypeRef);
	
		if (triggerTypeRef.current.value === 'auto') {
			// Auto-trigger specific null checks
			if (!minDepthRef.current || !maxDepthRef.current || !minMagnitudeRef.current || 
				!maxMagRef.current || !msgEnRef.current || !msgDvRef.current || 
				!msgBnRef.current || !effectiveHoursRef.current || !severityRef.current) {
				return;
			}
	
			const isMinDepth: boolean = validateField(minDepthRef);
			const isMaxDepth: boolean = validateField(maxDepthRef);
			const isMinMagnitude: boolean = validateField(minMagnitudeRef);
			const isMaxMagnitude: boolean = validateField(maxMagRef);
			const isMsgEn: boolean = validateField(msgEnRef);
			const isMsgDv: boolean = validateField(msgDvRef);
			const isMsgBn: boolean = validateField(msgBnRef);
			const isEffectiveHours: boolean = validateField(effectiveHoursRef);
			const isSeverity: boolean = validateField(severityRef);
	
			if (isValidName && isValidDepartment && isValidHz && isValidWarning && 
				isValidId && isTriggerType && isLocalization && isWorkflowType && 
				isMinDepth && isMaxDepth && isMinMagnitude && isMaxMagnitude && 
				isMsgEn && isMsgDv && isMsgBn && isEffectiveHours && isSeverity) {
				
				const tempVal: WorkflowTypes = {
					id: idRef,
					name: nameRef,
					department: departmentRef,
					hzType: hzTypeRef,
					warningType: warningTypeRef,
					workflowType: workflowTypeRef,
					triggerType: triggerTypeRef,
					localization: localizationRef
				};
				
				setList((prevState) => [...prevState, tempVal]);
				addInformations(
					idRef.current.value,
					nameRef.current.value,
					departmentRef.current.value,
					warningTypeRef.current.value,
					hzTypeRef.current.value,
					workflowTypeRef.current.value,
					triggerTypeRef.current.value,
					localizationRef.current.value,
					minDepthRef.current.valueAsNumber,
					maxDepthRef.current.valueAsNumber,
					minMagnitudeRef.current.valueAsNumber,
					maxMagRef.current.valueAsNumber,
					msgEnRef.current.value,
					msgDvRef.current.value, // No more null error!
					msgBnRef.current.value,
					effectiveHoursRef.current.valueAsNumber,
					severityRef.current.value
				);
				console.log("Location -> ", localizationRef.current)
			}
		} else {
			if (isValidName && isValidDepartment && isValidHz && isValidWarning && 
				isValidId && isTriggerType && isLocalization && isWorkflowType) {
				
				const tempVal: WorkflowTypes = {
					id: idRef,
					name: nameRef,
					department: departmentRef,
					hzType: hzTypeRef,
					warningType: warningTypeRef,
					workflowType: workflowTypeRef,
					triggerType: triggerTypeRef,
					localization: localizationRef
				};
				
				setList((prevState) => [...prevState, tempVal]);
				addInformations(
					idRef.current.value,
					nameRef.current.value,
					departmentRef.current.value,
					warningTypeRef.current.value,
					hzTypeRef.current.value,
					workflowTypeRef.current.value,
					triggerTypeRef.current.value,
					localizationRef.current.value
				);
			}
		}
	};

	const addInformations = async (warningid: string, username: string, department: string, warningtype: string, hazardtype: string, workflowType: string, workflowTriggerType: string, localization: string, minDepth?: number, maxDepth?: number, minMagnitude?: number, maxMagnitude?: number, msgEn?: string, msgDv?: string, msgBn?: string, effectiveHours?: number, severity?: string) => {
		
		setIsLoading(true)

		const body: APIRequestWorkflowInfo = {
			warningId: warningid,
			username: username,
			hazardType: hazardtype,
			warningType: warningtype,
			departments: department,
			workflowType: workflowType,
			triggerType: workflowTriggerType,
			localizationType: localization,
			areas: selectedCoordinate,
			localizationAreas: [],
			minDepth: minDepth || 0,
			maxDepth: maxDepth || 0,
			minMagnitude: minMagnitude || 0,
			maxMagnitude: maxMagnitude || 0,
			msgEn: msgEn ? msgEn : "N/A",
			msgDv: msgDv ? msgDv : "N/A",
			msgBn: msgBn ? msgBn : "N/A",
			effectiveHours: effectiveHours || 0,
			severity: severity || ""
			
		}
		//console.log("BODY -> ", body)
		const response = await APIAddWorkflowInfos(body)

		if (response.status)
		{
			setSelectedTab("design")
			setSelectedCoordinate([])
		}
		else
		{
			//showAlertDialog("Error", "❌ Information adding failed")
			showAlertDialog("Error", response.message)
		}
		// AddInfomationDetais(warningid, username, department, warningtype, hazardtype, workflowType, workflowTriggerType, localization)
		// 	.then(
		// 		(response: any) => {
		// 			//console.log(response)
		// 			//showAlertDialog("Success", "✅ Information added successfully.");
		// 			setSelectedTab("design");
		// 		},
		// 		(error: any) => {
		// 			//console.log(error);
		// 			showAlertDialog("Error", "❌ Information adding failed")
		// 		}
		// 	)
		// 	.finally(() => setIsLoading(false))
		setIsLoading(false)
	}

	// Handle design back button click
	const handleDesignBackClick = () => {
		setSelectedTab("information");
	};

	// Handle design finish button
	const handleDesignFinishClick = () => {
		console.log("clicked finish button")
	};

	// Get all available organization
  const getAllInfoWarningDiagram = async () => {
	//setIsLoading(true)
	setIsDataPickerLoading(true)

	const response = await APIGetAllWorkflowInfos()

	if (response.status)
	{
		//console.log("Response: ", response.data)
		setFilteredUserData(response.data)
		allUsers.current = response.data
		setIsDataPickerLoading(false)
		
	}
    // const token = localStorage.getItem("access_token");
    // //fetch("https://bos.beconx.live/api/v1/getallorganizations", {
    // fetch(BASE_URL + "/workflow_engine/api/v1/getallinformation", {
    //   method: "GET",
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     //console.log("Fetched info in Create Org:", data);
	// 	allUsers.current = data
    //     setFilteredUserData(data);
	// 	//console.log("DATA SET -> ", data)
    //   })
    //   .catch((err) => console.error("Error fetching Informations:", err))
	//   .finally(() => {
	// 	//setIsLoading(false)
	// 	setIsDataPickerLoading(false)
	//   })

    //allOrganizations.current = data
    //setFilteredOrganizationData(data)
  };

	useEffect(() => {
		getAllInfoWarningDiagram()
	}, []);

	// Handle tab click
	const handleTabClick = (tab: string) => {
		setSelectedTab(tab as TabTypes)
	}
	const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>): void => {

		const value = event.target.value
		if (value === "") 
		{
		  setFilteredUserData(allUsers.current);
		} 
		else 
		{
			setFilteredUserData(allUsers.current.filter((item) => {
				const type: string = item.workflowType === "prod" ? "Active" : item.workflowType === "test" ? "Test" : "Unknown"
				return item.warningId.toLowerCase().includes(value.toLowerCase()) || item.username.toLowerCase().includes(value.toLowerCase()) || type.toLowerCase().includes(value.toLowerCase())
			}))
		}
	}

	const [selectRow, setSelectRow] = useState<string[]>([])
	const [selectedCodes, setSelectedCodes] = useState(new Set());
	const handleSelectRow = (event: ChangeEvent<HTMLInputElement>, selected: AreaType) => {
		setSelectedCodes(prev => {
            const updated = new Set(prev);
            if (event.target.checked) {
                updated.add(event.target.name);
            } else {
                updated.delete(event.target.name);
            }
            return updated;
        })
		if (event.target.checked) {
			setSelectRow(prevState => [...prevState, selected.gnCode])
		} else {
			setSelectRow(prevState => prevState.filter(code => code !== selected.gnCode))
		}
	}

	// Calculate field count
	const sideFieldCount = (totalField: number): number => {
		if (totalField > 0) {
			const value = totalField % 2

			if (value === 0){
				return totalField / 2
			} else {
				return (totalField + 1) /2
			}
		} else {
			return totalField
		}
	}

	const [isTriggerTypeAuto, setIsTriggerTypeAuto] = useState<boolean>(false)
	const [selectedCoordinate, setSelectedCoordinate] = useState<Coordinate[][]>([])
	const handleChangeTriggerType = (event: ChangeEvent<HTMLSelectElement>) => {
		const value: string = event.target.value
		if (value === 'auto')
		{
			setIsTriggerTypeAuto(true)
		}
		else
		{
			setIsTriggerTypeAuto(false)
		}
	}

	return (
		<div className={`container-wrapper`}>
			<span className={`title`}>setup workflow</span>
			<div className="tab-area">
				{tabs.map((tab, index) => (
					<span key={index} style={{ borderStyle: selectedTab === tab ? "solid" : "none" }} onClick={() => handleTabClick(tab)} >
						{tab.replace(/_/g, " ")}
					</span>
				))}
			</div>
			<div
				style={{
					display: selectedTab === "information" ? "block" : "none",
					width: "100%",
					flexGrow: "1",
				}}
			>
				<div className={`configuration`}>
					<div className={`grid-layout-information`}>
						<div className={`left-side`}>
							{formItems.slice(0, sideFieldCount(formItems.length)).map((field, index) => (
								<InputGroup key={index} {...field} />
							))}
						</div>

						<div className={`right-side`}>
							{formItems.slice(sideFieldCount(formItems.length)).map((field, index) => (
								<InputGroup key={index} {...field} />
							))}
						</div>

						{isLocalizationTableOpen && (
							<div className="table-wrapper">
								<SpecificAreaTable data={areaTableData} handleSelectRow={handleSelectRow} selectedArea={selectRow}/>
							</div>
						)}

						{isTriggerTypeAuto && (
							<div className="map-container" style={{ gridArea: 'map' }}>
								<div className="trigger-region-select">
									<span>Select regions</span>
									<MapComp polygonMulti={setSelectedCoordinate} zoomLevel={3} defaultCenter={[107.21566, 10.14900]} initialMultiPolygon={initialMultiPolygon} clearButton={true}/>
								</div>
								<div className="threshold-field-wrapper">
									<span>Add Threshold values</span>
									<div>
										{thresholdFields.map((field, index) => (
											<InputGroup key={index} {...field} />
										))}
									</div>
								</div>
								<div className="info-field-wrapper">
									<span>Add Warning Info</span>
									<div>
										{infoFields.map((field, index) => (
											<InputGroup key={index} {...field} />
										))}
									</div>
								</div>
								<div className="message-field-wrapper">
									<span>Add Warning Message</span>
									{messageFields.map((field, index) => (
										<InputGroup key={index} {...field} />
									))}
								</div>
							</div>
						)}

						<div className={`button-wrapper`} style={{ gridArea: "button" }}>
							<div className={`left-side`}></div>
							<div className={`right-side`}>
								<button className={`button-normal`} onClick={(e) => handleInfoNextClick()} >
									next
								</button>
							</div>
						</div>
						{isDataPickerOpen && (
							<div className="data-picker-table-wrapper">
								<div className="data-picker-table-container">
									<div className="search-wrapper">
										<input type="text" placeholder="Search workflow" onChange={(e) => handleChangeExistingDataSearch(e)} />
										<div className="search-icon">
											<SearchIcon width="1rem" color="var(--color-main-white)" />
										</div>
										<div className="close-icon" onClick={(e) => setIsDataPickerOpen(false)}>
											<CloseIcon width="1.5rem" color="var(--color-text)" />
										</div>
									</div>
									<div className="row header">
										<span style={{ width: '33%' }}>Warning ID</span>
										<span style={{ width: '33%' }}>Flow Name</span>
										<span style={{ width: '33%' }}>Flow Type</span>
									</div>

									{isDataPickerLoading ? (
										<div className="searching-data">
											<img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
											<span>Searching workflow data...</span>
										</div>
										) : (
											<div className="data-wrapper">
												{filteredUsersData.map((user, index) => (
													<div key={index} className="row" onClick={(e) => handleClickFilteredInfoWarningDiagram(user)} >
														<span style={{width: '33%'}}>{user.warningId}</span>
														<span style={{width: '33%'}}>{user.username}</span>
														<span style={{width: '33%'}}>{user.workflowType === "prod" ? "Active" : user.workflowType === "test" ? "Test" : "Unknown"}</span>
													</div>
												))}
											</div>
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<div
				style={{
					display: selectedTab === "design" ? "block" : "none",
					width: "100%",
					height: "100%",
				}}
			>
				<div className={`configuration`}>
					<div className={`grid-layout-design`}>
						<div className={`canvas-wrapper`}>
							{selectedTab === "design" && <FlowDiagramWrapper ref={flowRef} list={list} hazardType={hzTypeRef.current ? hzTypeRef.current.value : '' } flowId={idRef.current ? idRef.current.value : ''} />}
						</div>
						<div className={`button-wrapper`} style={{ gridArea: "buttons" }}>
							<div className={`left-side`}>
								<button className={`button-normal`} onClick={(e) => handleDesignBackClick()} >
									back
								</button>
							</div>
							<div className={`right-side`}>
								<button className={`button-normal`} onClick={() => {
									showAlertDialog(
										"Confirm Submit",
										"Are you sure you want to save this workflow?",
										() => flowRef.current?.saveFun())
									}} 
								>
									finish
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			{alertDialogState && (
				<AlertDialog
					title={alertTitle}
					description={alertDescription}
					windowState={alertDialogState}
					setWindowState={setAlertDialogState}
					function={alertYesCallback}
					okFunction={alertOkCallback}
				/>
			)}
			{isLoading && (
				<LoadingScreen />
			)}
		</div>
	);
};

export default Configuration;
